<template>
  <div id="app">
	
    <router-view/>
  </div>
</template>

<script>
	import * as types from './types'
  import '../static/fxView/js/popper.min.js';
  import '../static/fxView/js/bootstrap.min.js';
	//import '../static/fxView/js/jquery.min.js';
  import '../static/fxView/js/custom.js';  
  import { fxViewMixins } from '@/plugins/fxView'
  import i18n from '@/plugins/lang/i18n';
    import { mapActions } from 'vuex'
  export default {
    name: 'App',
	mixins: [fxViewMixins],
    watch : {
        $route(to,from){
          console.log('royut', this.$route.name);
            if(this.$route.name == 'fxView.web_trade_link' || this.$route.name == 'fxView.web_trade_link_new'){
                $('#chat-widget-container').addClass("d-none")
            }else{
                $('#chat-widget-container').removeClass("d-none")
            }
        }
    },
    data () { 
      return {
		    languageChangeDetect : ''
      }
    },
    created(){
		this.$store.dispatch(types.RUN_STATE_LOAD)
		
    },
  }
</script>

<style>
  @import '../static/fxView/css/bootstrap.min.css';
  @import '../static/fxView/css/apidoc_style.css';
  @import '../static/fxView/css/style.css';
  @import '../static/fxView/css/responsive.css';
  
</style>


// WEBPACK FOOTER //
// src/App.vue